import {
  Alert,
  DialogContent,
  DialogContentText,
  Grid,
  Typography,
} from "@mui/material";
import { smsTemplateFields } from "./smsAllFields";
import useStyles from "../../../../components/common/model/styles";
import FormField from "../../../../components/common/FormField";
import Notification from "../../../../components/common/notification/Notification";
import Popup from "../../../../components/common/model/Popup";
import SAVE_ICON from "../../../../assets/check-mark.png";
import CLOSE_ICON from "../../../../assets/closeModel.png";
import RESET_ICON from "../../../../assets/trash.png";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  addSmsTemplateAction,
  getAllEventsAction,
} from "../../../../store/reducers/emailTemplateSlice";
import { useSelector } from "react-redux";
import Validation from "../../../../utils/Validation";
import { setNotificationAction } from "../../../../store/reducers/mmymSlice";
import ResetFormAlert from "./ResetFormAlert";
import { getCaretCharacterOffsetWithin } from "../../../../utils/utils";
import {
  initialSmsTemplateLocalState,
  resetNewSmsTemplateLocal,
  setAddSmsTemplateResponse,
  setNewSmsTemplateLocal,
  setUpdateSmsTemplateAction,
  updateSmsTemplateAction,
} from "../../../../store/reducers/smsTemplateSlice";
interface ManageSmsTemplateProps {
  open: boolean; // Define the 'open' prop
  onHide: () => void; // Define the 'onHide' prop
  title: string; // Define the 'title' prop
  selectTemplate?: any; // Adjust type as per your requirement
  setSelectedRow?: any; // Adjust type as per your requirement
}

const ManageSmsTemplate = (props: ManageSmsTemplateProps) => {
  const { selectTemplate, setSelectedRow, onHide, open, title } = props;

  const { allEvents } = useSelector((state: any) => state.emailTemplates);

  const {
    newSmsTemplateLocal,
    isSmsTemplateResponse,
    isSmsTemplateUpdateSuccess,
  } = useSelector((state: any) => state.smsTemplate);

  const { leadStageWithPlaceholders } = useSelector(
    (state: any) => state.emailTemplates,
  );

  const classes = useStyles();
  const dispatch = useDispatch();

  const [isReset, setIsReset] = useState(false);

  const { template_name, body, lead_stage } =
    newSmsTemplateLocal?.smsTemplate || {};

  const [
    error,
    checkValidator,
    resetValidator,
    resetAllValidator,
    isError,
    isErrorOptional,
  ]: any = Validation({
    template_name,
    body,
    lead_stage,
  });

  const [fullWidth, setFullWidth] = useState(true);
  const [isActionCalled, setIsActionCalled] = useState(false);
  const [focusedField, setFocusedField] = useState<any>({
    id: "",
    cursorPosition: 0,
  });



  useEffect(() => {
    if (selectTemplate) {
      console.log("selectTemplate", selectTemplate);
      dispatch(
        setNewSmsTemplateLocal({
          smsTemplate: {
            ...newSmsTemplateLocal?.smsTemplate,
            ...selectTemplate,
          },
        }),
      );
    }
  }, [selectTemplate]);

  const eventNames = allEvents.map((event: any) => event);

  const extractPlaceholders = (value: string) => {
    const regex = /{{(.*?)}}/g;
    let match;
    const placeholders = new Set();
    while ((match = regex.exec(value)) !== null) {
      placeholders.add(match[1]);
    }
    return Array.from(placeholders);
  };

  const onChangeAction = (event: any) => {
    if (isReset) return;

    const { id, value, type, name } = event.target;
    const key = type === "radio" ? name : id;

    let updatedSmsTemplate = {
      ...newSmsTemplateLocal?.smsTemplate,
      [key]: value,
    };

  // ✅ ONLY Lead Stage Logic
  if (key === "lead_stage") {
    const selectedLeadStage = leadStageWithPlaceholders.find(
      (item: any) => item.stage === value
    );

    updatedSmsTemplate = {
      ...updatedSmsTemplate,
      lead_stage: value,
      placeholders: selectedLeadStage?.placeholders || [],
    };
  }

    // ✅ Extract placeholders only when typing body content
    if (key === "body") {
      const placeholders = extractPlaceholders(value);
      updatedSmsTemplate.placeholders = Array.from(
        new Set([
          ...(newSmsTemplateLocal?.smsTemplate?.placeholders || []),
          ...placeholders,
        ]),
      );
    }

    dispatch(setNewSmsTemplateLocal({ smsTemplate: updatedSmsTemplate }));
    resetValidator(key);
  };

  const onBlurAction = (e: any) => {
    const { id, value } = e.target;
    checkValidator(id);
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    checkValidator();
    setIsActionCalled(true);
  };

  useEffect(() => {
    if (isActionCalled) {
      console.log("error", error);
      console.log("isError()", isError());
      console.log(
        "newSmsTemplateLocal?.smsTemplate",
        newSmsTemplateLocal?.smsTemplate,
      );
      if (
        !isError() &&
        !isErrorOptional() &&
        error !== null &&
        isActionCalled
      ) {
        const { category, ...payload } = newSmsTemplateLocal?.smsTemplate;
        if (selectTemplate) {
          dispatch(updateSmsTemplateAction(payload));
        } else {
          dispatch(addSmsTemplateAction(payload));
        }
      } else {
        console.log("error", error);
      }
      setIsActionCalled(false);
    }
    setIsActionCalled(false);
  }, [isActionCalled]);

  const hideHandler = () => {
    dispatch(setUpdateSmsTemplateAction(false));
    dispatch(setAddSmsTemplateResponse(false));
    dispatch(setNotificationAction({ message: [], severity: "error" }));
    props.onHide();
    setSelectedRow(null);
    setTimeout(() => {
      dispatch(resetNewSmsTemplateLocal());
    }, 300);
  };

  useEffect(() => {
    if (isSmsTemplateResponse || isSmsTemplateUpdateSuccess) {
      hideHandler();
    }
  }, [isSmsTemplateResponse, isSmsTemplateUpdateSuccess]);

  const handleTagClick = (tagLabel: string) => {
    setIsReset(false);
    console.log("focusedField", focusedField);
    if (focusedField?.id) {
      const fieldElement = document.getElementById(
        focusedField?.id,
      ) as HTMLInputElement;
      if (fieldElement) {
        const cursorPosition = fieldElement.selectionStart || 0;
        const textBeforeCursor = fieldElement.value.substring(
          0,
          cursorPosition,
        );
        const textAfterCursor = fieldElement.value.substring(
          cursorPosition,
          fieldElement.value.length,
        );
        const newValue = `${textBeforeCursor}${tagLabel}${textAfterCursor}`;
        fieldElement.value = newValue;
        onChangeAction({ target: { id: focusedField?.id, value: newValue } });
      }
    }
  };

  const handlePosition = (id: string) => {
    if (id) {
      setFocusedField({
        id,
        cursorPosition: getCaretCharacterOffsetWithin(id) || 0,
      });
    }
  };

  const [alerModeShow, setAlertModelShow] = useState(false);
  const [isClickReset, setIsClickReset] = useState(false);

  useEffect(() => {
    if (isClickReset) {
      handleClear();
      setAlertModelShow(false);
      setIsClickReset(false);
    }
  }, [isClickReset]);

  const handleClear = () => {
    if (selectTemplate?.template_id) {
      setTimeout(() => {
        dispatch(
          setNewSmsTemplateLocal({
            smsTemplate: selectTemplate,
          }),
        );
      }, 300);
      dispatch(
        setNewSmsTemplateLocal({
          smsTemplate: selectTemplate,
        }),
      );
      resetAllValidator();
    } else {
      dispatch(setNewSmsTemplateLocal(initialSmsTemplateLocalState));
      setTimeout(() => {
        dispatch(resetNewSmsTemplateLocal());
      }, 300);
      resetAllValidator();
    }
    setIsReset(false);
  };

  const openClearPopup = () => {
    setAlertModelShow(true);
  };

  const updateField = smsTemplateFields.map((field) => {
    if(field.id === "lead_stage"){
      return {
        ...field,
        options: leadStageWithPlaceholders.map((item: any) => ({
          label: item.stage,
          id: item.stage,
        })),
      }
    }
    return field;
  });

  return (
    <>
      <Popup
        open={open}
        title={title}
        onHide={hideHandler}
        fullWidth={fullWidth}
        maxWidth={"lg"}
        aria-describedby="alert-dialog-slide-description"
        header={
          <>
            <img
              onClick={(e: any) => handleSubmit(e)}
              src={SAVE_ICON}
              className={classes.checkicons}
              alt="save"
            />
            <img
              onClick={openClearPopup}
              src={RESET_ICON}
              className={classes.deleteicons}
              alt="delete"
            />
            <img
              onClick={hideHandler}
              src={CLOSE_ICON}
              className={classes.closeicons}
              alt="close"
            />
          </>
        }
      >
        <DialogContent>
          <DialogContentText className={classes.formAddBox}>
            <>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Notification />
                </Grid>
                <Grid item xs={12} md={9}>
                  <Grid container spacing={2}>
                    {updateField?.map((field, i) => {
                      // Skip the "event" field entirely
                      if (field?.id === "event") return null;
                      return (
                        <>
                          <Grid
                            item
                            xs={12}
                            md={
                              field?.type === "richtext" ||
                              field?.type === "radio" ||
                              field?.type === "textarea"
                                ? 12
                                : 6
                            }
                            key={i}
                            sx={{ padding: "0px 4px" }}
                          >
                            <Grid container spacing={2}>
                              <FormField
                                key={field.id}
                                // onPaste={(e) => e.preventDefault()}
                                onKeyDown={(event: any) => {
                                  setIsReset(false);
                                  console.log(
                                    "event log-",
                                    event,
                                    event.target.value + event.key,
                                  );
                                  if (field?.type === "textarea") {
                                    return event;
                                  }
                                  if (
                                    event.keyCode === 8 ||
                                    event.keyCode === 9 ||
                                    event.keyCode === 37 ||
                                    event.keyCode === 38 ||
                                    event.keyCode === 39 ||
                                    event.keyCode === 40 ||
                                    event.keyCode === 18 ||
                                    event.keyCode === 17 ||
                                    event.ctrlKey
                                  )
                                    return event;
                                  if (
                                    field?.patternAllowed &&
                                    !field?.patternAllowed.test(event.key)
                                  ) {
                                    event.preventDefault();
                                  } else if (
                                    field?.patternAllowed &&
                                    !field?.patternAllowed.test(
                                      event.target.value + event.key,
                                    )
                                  ) {
                                    event.preventDefault();
                                  }
                                }}
                                {...{
                                  ...field,
                                  // placeholderValue: placeholderTagValue,
                                  value: newSmsTemplateLocal?.smsTemplate
                                    ? newSmsTemplateLocal?.smsTemplate[
                                        field?.id
                                      ]
                                    : "",
                                  ...{
                                    variant: "outlined", // Adding this variant prop
                                    onChange: onChangeAction,
                                    onBlur: onBlurAction,

                                    onKeyUp: () => handlePosition(field.id),

                                    InputProps: {
                                      ...(field?.inputProps &&
                                        field?.inputProps),

                                      sx:
                                        field?.type === "text" ||
                                        field?.type === "password"
                                          ? { height: "36px" }
                                          : {
                                              padding: "10px 4px",
                                              height: "36px",
                                            },
                                    },

                                    error: error && error[field?.id],
                                    selectedValues:
                                      newSmsTemplateLocal?.smsTemplate[
                                        field?.id
                                      ],
                                  },
                                  onFocus: () => handlePosition(field.id),
                                }}
                              />
                            </Grid>
                          </Grid>
                        </>
                      );
                    })}
                  </Grid>
                </Grid>
                <Grid item xs={12} md={3}>
                  <Grid
                    container
                    spacing={2}
                    justifyContent="center"
                    textAlign="center"
                  >
                    <Typography
                      sx={{
                        position: "absolute",
                        textAlign: "center",
                        fontWeight: 600,
                        marginTop: "-10px",
                      }}
                    >
                      {" "}
                      SMS Tags
                    </Typography>
                    {eventNames
                      .filter(
                        (x: any) =>
                          x.category ===
                          newSmsTemplateLocal?.smsTemplate?.category,
                      )[0]
                      ?.events?.filter(
                        (event: any) =>
                          event.event_name ===
                          newSmsTemplateLocal?.smsTemplate?.event,
                      ) // Filter based on the selected event ID
                      ?.map((event: any) =>
                        event.placeholders ? (
                          event.placeholders?.map(
                            (placeholder: any, i: number) => (
                              <Grid
                                key={`${event.event_id}-${i}`}
                                item
                                xs={12}
                                md={6}
                                justifyContent="center"
                                textAlign="center"
                              >
                                <span
                                  style={{
                                    background: "#e0e0e0",
                                    color: "#666",
                                    padding: "8px 10px",
                                    fontWeight: 600,
                                    cursor: "pointer",
                                    width: "95%",
                                    display: "flex",
                                    textAlign: "center",
                                    fontSize: "14px",
                                  }}
                                  onClick={() =>
                                    handleTagClick(`{{${placeholder}}}`)
                                  } // Ensure the tag click inserts the correct placeholder format
                                >
                                  {placeholder}
                                </span>
                              </Grid>
                            ),
                          )
                        ) : (
                          <Typography
                            style={{ marginTop: "16px", color: "#6b6b6b" }}
                          >
                            Tags Not Found !
                          </Typography>
                        ),
                      )}
                  </Grid>
                  <br />
                  {newSmsTemplateLocal?.smsTemplate?.event && (
                    <Alert severity="info" sx={{ mb: 2 }}>
                      Only the provided tags are allowed. Please use them while
                      creating the template — don’t use any other tags. <br />
                      Always write tag names inside{" "}
                      <strong>double curly braces</strong>, for example:{" "}
                      <code>
                        {"{{username}}"}, {"{{CompanyName}}"}
                      </code>
                      .
                    </Alert>
                  )}
                </Grid>
              </Grid>
            </>
          </DialogContentText>
        </DialogContent>
      </Popup>
      {alerModeShow && (
        <ResetFormAlert
          open={alerModeShow}
          title=""
          alertModalShow={alerModeShow}
          setAlertModelShow={setAlertModelShow}
          setIsClickReset={setIsClickReset}
        />
      )}
    </>
  );
};
export default ManageSmsTemplate;
